import { render } from "./LinkageSignupProgress.vue?vue&type=template&id=56296006&ts=true"
import script from "./LinkageSignupProgress.vue?vue&type=script&lang=ts"
export * from "./LinkageSignupProgress.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1111083459/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__